import { render, staticRenderFns } from "./RelatedSearchResults.vue?vue&type=template&id=127b27a0"
import script from "./RelatedSearchResults.vue?vue&type=script&lang=ts"
export * from "./RelatedSearchResults.vue?vue&type=script&lang=ts"
import style0 from "./RelatedSearchResults.vue?vue&type=style&index=0&id=127b27a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports